export async function copyText(text: string): Promise<boolean> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      // Some browsers expose Clipboard API but deny it outside a secure context.
    }
  }

  const input = document.createElement('textarea')
  input.value = text
  input.setAttribute('readonly', '')
  input.style.position = 'fixed'
  input.style.opacity = '0'
  document.body.append(input)

  try {
    input.select()
    return typeof document.execCommand === 'function' && document.execCommand('copy')
  } finally {
    input.remove()
  }
}
